import Modal from "@/components/Modal/Modal";

import { RootState } from "../../../store";
import { ConnectedProps, connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, toast } from "../../../components";
import Dropdown from "react-bootstrap/Dropdown";
import { useEffect, useState, useCallback, useMemo, useRef } from "react";
import CreateMetaPreset from "@/components/MetaPresets/CreateMetaPreset";
import { getMostFrequentAll } from "@/store/user/user.action";
import {
  deletePreset,
  getCurrentPresetDetails,
  getLiveList,
} from "@/store/media/media.action";
import ProcessingPreset from "@/components/MetaPresets/ProcessingPreset";
import { getPresetList } from "@/store/media/media.action";
import SocialPresets from "@/components/MetaPresets/SocialPresets";
import { getAddPreset } from "@/store/media/media.action";
import {
  formatTimestampToAgo,
  secondsToHms,
  useClickOutside,
} from "../../../utils";
import { updatePreset } from "@/store/media/media.action";
import PreviousMediaMeta from "@/components/MetaPresets/PreviousMediaMeta";
import BrandingPreset from "@/components/MetaPresets/BrandingPreset";
import PageHeader from "@/components/Layout/PageHeader";
import { getListMedia } from "@/store/media/media.action";
import { MediaModel, PresetListModel, UserModel } from "@/database";
import SidebarNavigation, {
  SidebarMenuItem,
} from "@/components/SidebarNavigation/SidebarNavigation";
import {
  EllipsisVertical,
  Database,
  Cog,
  Send,
  Palette,
  SettingsIcon,
} from "lucide-react";
import { NoContentFound } from "@/utils/ui/NoContent";
import { Skeleton } from "../../../components";
import {
  setCurrentPresetDetails,
  setPresetList,
} from "@/store/media/media.slice";
import AddPreset from "@/components/Presets/AddPreset";

import { getListProduct } from "@/store/constants/constants.action";
import { filterPresetsByTeamsAndType } from "@/utils/mediautils/CommonFunctions";

interface RenderCreateMetaPresetProps {
  name?: string;
  createdBy?: string;
  visibility?: string;
  createdAt?: number;
  meta?: PresetListModel | null;
  team?: string[];
}

interface PresetSectionProps {
  title: string;
  description: string;
  presetList: PresetListModel[];
  onAddNew: () => void;
  constUserList: UserModel[];
}

interface ModalConfig {
  isOpen: boolean;
  title: string;
  width: string;
  height: string;
  footer: React.ReactNode;
  children: React.ReactNode;
}

interface PresetTypeConfig {
  type: string;
  title: string;
  description: string;
  modalTitle: string;
  modalWidth: string;
  requiresMediaSelection: boolean;
}

// Constants
const PRESET_TYPES: PresetTypeConfig[] = [
  {
    type: "meta",
    title: "META",
    description: "",
    modalTitle: "Create",
    modalWidth: "1000px",
    requiresMediaSelection: true,
  },
  {
    type: "processing",
    title: "PROCESSING",
    description: "",
    modalTitle: "Create",
    modalWidth: "800px",
    requiresMediaSelection: false,
  },
  {
    type: "social",
    title: "SOCIAL",
    description: "",
    modalTitle: "CREATE",
    modalWidth: "800px",
    requiresMediaSelection: true,
  },
  {
    type: "branding",
    title: "BRANDING",
    description: "",
    modalTitle: "Create",
    modalWidth: "1000px",
    requiresMediaSelection: false,
  },
  {
    type: "transcoding",
    title: "TRANSCODING",
    description: "",
    modalTitle: "Create",
    modalWidth: "1000px",
    requiresMediaSelection: false,
  },
];

const MetaPresets = ({
  bunchLanguage,
  genre,
  getLiveList,
  constUserList,
  singleCurrentUser,
  bunchProductList,

  productList,
  presetList,
  getPresetList,
  liveList,
  getAddPreset,
  updatePreset,
  currentPresetDetails,
  business,
  mediaList,
  deletePreset,
  getListMedia,
  isLoading,
  setPresetList,
  getListProduct,
  getCurrentPresetDetails,
  bunchLanguageList,
  bunchCategoryList,
  bunchBusinessList,
}: Props) => {
  const currentLocation = useLocation();

  const navigate = useNavigate();

  // Modal states
  const [modalStates, setModalStates] = useState({
    isShowAddNew: false,
    isShowProcessing: false,
    isShowSocial: false,
    isPrevMediaList: false,
    isBrandingPreset: false,
    isTranscodingPreset: false,
  });
  const metaRef = useRef<HTMLDivElement>(null);
  const transcodingDropdownRef = useRef<HTMLDivElement>(null);

  // Define sidebar menu items
  const sidebarMenuItems: SidebarMenuItem[] = [
    // {
    //   id: "meta",
    //   label: "Meta",
    //   icon: Database,
    //   sectionRef: metaRef,
    //   url: `/meta-presets/meta${currentLocation.search}`,
    // },
    {
      id: "processing",
      label: "Processing",
      icon: Cog,
      sectionRef: metaRef,
      url: `/meta-presets/processing${currentLocation.search}`,
    },
    {
      id: "social",
      label: "Social",
      icon: Send,
      sectionRef: metaRef,
      url: `/meta-presets/social${currentLocation.search}`,
    },
    {
      id: "branding",
      label: "Branding",
      icon: Palette,
      sectionRef: metaRef,
      url: `/meta-presets/branding${currentLocation.search}`,
    },
    {
      id: "transcoding",
      label: "Transcoding",
      icon: SettingsIcon,
      sectionRef: metaRef,
      url: `/meta-presets/transcoding${currentLocation.search}`,
    },
  ];

  // Other states
  const [meta, setMeta] = useState<PresetListModel | null>(null);

  const [isEdit, setIsEdit] = useState(false);
  const [prevMediaMeta, setPrevMediaMeta] = useState<MediaModel | null>(null);
  const [isMetaPreset, setIsMetaPreset] = useState<boolean>(false);
  const [hasChanges, setHasChanges] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState("meta");
  const [showOptions, setShowOptions] = useState(false);
  const [metaType, setMetaType] = useState<string>("");
  const [activeSection, setActiveSection] = useState<string>("");
  const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);
  const [isSocialBtnDisabled, setIsSocialBtnDisabled] = useState(true);
  const [isTranscodingDropdownOpen, setIsTranscodingDropdownOpen] =
    useState(false);
  const [transcodingModalType, setTranscodingModalType] = useState<string>("");
  const [hasTranscodingChanges, setHasTranscodingChanges] =
    useState<boolean>(false);

  const [duration, setDuration] = useState<number>(0);

  // Determine active tab from current route
  const getActiveTabFromRoute = useCallback((pathname: string) => {
    if (pathname.includes("/meta-presets/")) {
      const tabFromRoute = pathname.split("/meta-presets/")[1];
      if (PRESET_TYPES.some((type) => type.type === tabFromRoute)) {
        return tabFromRoute;
      }
    }
    return "meta"; // default tab
  }, []);

  // Sync active tab with route
  useEffect(() => {
    const tabFromRoute = getActiveTabFromRoute(currentLocation.pathname);
    setActiveTab(tabFromRoute);
  }, [currentLocation.pathname, getActiveTabFromRoute]);

  // Redirect to default tab if accessing base route
  useEffect(() => {
    if (currentLocation.pathname === "/meta-presets") {
      navigate(`/meta-presets/meta${currentLocation.search}`, {
        replace: true,
      });
    }
  }, [currentLocation.pathname, currentLocation.search, navigate]);

  // Computed preset lists
  const presetLists = useMemo(
    () => ({
      meta:
        filterPresetsByTeamsAndType(bunchProductList, presetList, "meta") || [],
      processing:
        filterPresetsByTeamsAndType(
          bunchProductList,
          presetList,
          "processing"
        ) || [],
      social:
        filterPresetsByTeamsAndType(bunchProductList, presetList, "social") ||
        [],
      branding:
        filterPresetsByTeamsAndType(bunchProductList, presetList, "branding") ||
        [],
      transcoding:
        presetList?.filter(
          (item: PresetListModel) =>
            item?.sub_type === "audio" || item?.sub_type === "video"
        ) || [],
    }),
    [presetList, bunchProductList]
  );

  const currentPresetConfig = useMemo(() => {
    return (
      PRESET_TYPES.find((config) => config.type === activeTab) ||
      PRESET_TYPES[0]
    );
  }, [activeTab]);

  // Helper functions
  const resetFormStates = useCallback(() => {
    setHasChanges(false);
  }, []);

  useEffect(() => {
    if (meta?.team?.length && meta?.team?.length > 0) {
      getListProduct({});
    }
  }, [meta]);

  const closeModal = useCallback(() => {
    setModalStates({
      isShowAddNew: false,
      isShowProcessing: false,
      isShowSocial: false,
      isPrevMediaList: false,
      isBrandingPreset: false,
      isTranscodingPreset: false,
    });
    resetFormStates();
    setMeta(null);
    setIsMetaPreset(false);
    setCurrentPresetDetails(null as any);
    setPrevMediaMeta(null);
    setIsEdit(false);
    setShowOptions(false);
    setIsTranscodingDropdownOpen(false);
    setTranscodingModalType("");
    setHasTranscodingChanges(false);
  }, [resetFormStates]);

  const updateModalState = useCallback(
    (key: keyof typeof modalStates, value: boolean) => {
      setModalStates((prev) => ({ ...prev, [key]: value }));
    },
    []
  );

  const handlePrevMediaMeta = useCallback(
    (meta: MediaModel | null) => {
      setPrevMediaMeta(meta);
      if (!isEdit) {
        resetFormStates();
      }
    },
    [isEdit, resetFormStates]
  );

  // useEffect(() => {
  //   getListMedia({});
  // }, []);

  // Generic submit handler
  const createSubmitHandler = useCallback(
    (presetType: string) => {
      return async (payload: any) => {
        const { presetName, visibility, status, ...restPayload } = payload;

        if (!isEdit) {
          // Add debugging to see when presetList is empty

          if (!presetList || presetList.length === 0) {
            // Optionally show a warning to the user
            // if (!window.confirm('Preset list is still loading. Continue anyway?')) {
            //   return;
            // }
          }

          const presetExists = presetList?.some(
            (item: PresetListModel) =>
              item.name === presetName &&
              item.type === presetType &&
              item.team?.[0] === visibility?.[0]
          );

          if (presetExists) {
            return;
          }
        }

        const baseData = {
          name: presetName,
          team: visibility,
          sub_type: "",
          status: status,
          type: presetType,
        };

        let data;
        if (presetType === "meta") {
          data = {
            ...baseData,
            description: "test",
            media: [{ ...restPayload }],
          };
        } else if (presetType === "processing") {
          data = {
            ...baseData,
            processing: [{ ...restPayload }],
          };
        } else {
          data = payload; // For social and branding
        }

        try {
          if (isEdit) {
            const response = await updatePreset({ ...data, id: meta?.id });
          } else {
            const response = await getAddPreset(data);
          }
          setIsSocialBtnDisabled(true);
          closeModal();
        } catch (error) {
          // toast.error('Operation failed');
        }
      };
    },
    [isEdit, meta?.id, updatePreset, getAddPreset, closeModal, presetList]
  );

  const handleSubmit = createSubmitHandler("meta");
  const handleProcessingSubmit = createSubmitHandler("processing");
  const handleSocialSubmit = createSubmitHandler("social");
  const handleBrandingSubmit = createSubmitHandler("branding");

  // Event handlers
  const handleCreate = useCallback(() => {
    const event = new Event("createMetaPreset");
    window.dispatchEvent(event);
  }, []);

  const handleSelectMedia = useCallback(() => {
    const event = new Event("selectMedia");
    window.dispatchEvent(event);
  }, []);

  const handleEdit = useCallback(
    (meta: PresetListModel | null) => {
      setMeta(meta);
      setIsEdit(true);
      resetFormStates();

      // Check if it's a transcoding preset (has sub_type of 'audio' or 'video')
      const isTranscodingPreset =
        meta?.sub_type === "audio" || meta?.sub_type === "video";

      if (isTranscodingPreset) {
        // For transcoding presets, set the modal type and open transcoding modal
        setTranscodingModalType(meta?.sub_type || "video");
        updateModalState("isTranscodingPreset", true);
        return;
      }

      const modalMap = {
        meta: "isShowAddNew",
        processing: "isShowProcessing",
        social: "isShowSocial",
        branding: "isBrandingPreset",
      };

      const modalKey = modalMap[meta?.type as keyof typeof modalMap];

      if (meta?.id && meta?.type === "meta") {
        // For meta presets, wait for currentPresetDetails to load before opening modal
        getCurrentPresetDetails({ id: meta?.id }).then(() => {
          if (modalKey) {
            updateModalState(modalKey as keyof typeof modalStates, true);
          }
        });
      } else {
        // For other preset types, open modal immediately
        if (modalKey) {
          updateModalState(modalKey as keyof typeof modalStates, true);
        }
      }
    },
    [resetFormStates, updateModalState, getCurrentPresetDetails]
  );

  const openModal = useCallback(
    (type?: string) => {
      updateModalState("isPrevMediaList", false);
      resetFormStates();

      if (!isMetaPreset) {
        updateModalState("isShowSocial", true);
      } else {
        updateModalState("isShowAddNew", true);
      }
    },
    [isMetaPreset, resetFormStates, updateModalState]
  );

  const handleHasChanges = useCallback((hasChanges: boolean) => {
    setHasChanges(hasChanges);
  }, []);

  const handleTranscodingHasChanges = useCallback((hasChanges: boolean) => {
    setHasTranscodingChanges(hasChanges);
  }, []);

  const handleSave = (data: any, isEdit: boolean) => {
    if (data?.flavours?.length === 0) {
      toast.fail("Please select at least one flavour");

      return;
    }
    if (isEdit) {
      updatePreset(data);
    } else {
      getAddPreset(data);
    }
    setModalStates({
      isShowAddNew: false,
      isShowProcessing: false,
      isShowSocial: false,
      isPrevMediaList: false,
      isBrandingPreset: false,
      isTranscodingPreset: false,
    });
  };

  const handleBack = useCallback(() => {
    setIsEdit(false);
    setModalStates({
      isShowAddNew: false,
      isShowProcessing: false,
      isShowSocial: false,
      isPrevMediaList: true,
      isBrandingPreset: false,
      isTranscodingPreset: false,
    });
  }, []);

  const handleDelete = useCallback(
    (meta: PresetListModel | null) => {
      deletePreset({ id: meta?.id });
      closeModal();
    },
    [deletePreset]
  );

  // Create add new handler for each preset type
  const createAddNewHandler = useCallback(
    (presetType: string) => {
      return () => {
        resetFormStates();

        if (presetType === "meta") {
          updateModalState("isPrevMediaList", true);
          setIsMetaPreset(true);
        } else if (presetType === "processing") {
          updateModalState("isShowProcessing", true);
        } else if (presetType === "social") {
          updateModalState("isPrevMediaList", true);
        } else if (presetType === "branding") {
          updateModalState("isBrandingPreset", true);
        } else if (presetType === "transcoding") {
          updateModalState("isTranscodingPreset", true);
        }
      };
    },
    [resetFormStates, updateModalState]
  );

  // useEffect(() => {
  //   setPresetList({ isLoading: true, error: "" });
  //   getPresetList();
  // }, [singleCurrentUser]);

  // useEffect(() => {
  //   getLiveList();
  // }, []);

  // Handle click outside for transcoding dropdown
  useClickOutside(transcodingDropdownRef, () =>
    setIsTranscodingDropdownOpen(false)
  );

  // Components
  const PresetCard = useCallback(
    ({
      name,
      createdBy,
      team,
      createdAt,
      meta,
    }: RenderCreateMetaPresetProps) => (
      <div
        className="col-sm-12 col-md-6 col-lg-4 pointer"
        onClick={() => handleEdit(meta || null)}
      >
        <div className="card p-3 position-relative catRow">
          <div className="d-flex gap-3 align-items-start">
            <h6 className="flex-grow-1 anchor">{name}</h6>
            <div className="d-flex gap-3">
              <span
                className={`badge ${
                  meta?.status === 1 ? "bg-success" : "bg-danger"
                } text-white`}
              >
                {meta?.status === 1 ? "Active" : "Inactive"}
              </span>

              {/* <i className="bi bi-trash pointer fs-5" onClick={() => handleDelete(meta || null)}></i> */}
            </div>
          </div>
          <div className="text-secondary my-1">
            {createdBy}, {formatTimestampToAgo(createdAt || 0)}
          </div>
          <div className="text-secondary">
            team:{" "}
            {bunchProductList && bunchProductList.length > 0
              ? bunchProductList
                  ?.filter((item: any) => team?.includes(item?.id))
                  ?.map((item: any) => item?.name)
                  .join(", ")
              : "Loading..."}
          </div>

          <div className="H" style={{ cursor: "pointer" }}>
            <i
              className="bi bi-pencil"
              onClick={() => handleEdit(meta || null)}
            ></i>
          </div>
        </div>
      </div>
    ),
    [handleEdit, handleDelete, bunchProductList]
  );
  const getCurrentMenuItem = () => {
    const currentPath = currentLocation.pathname + currentLocation.search;
    return sidebarMenuItems.find((item) => {
      if (!item.url) return false;
      const itemUrl = new URL(item.url, window.location.origin);
      const itemPath = itemUrl.pathname;
      const itemSearch = itemUrl.search;
      return currentPath === itemPath + itemSearch;
    });
  };

  const currentMenuItem = getCurrentMenuItem();
  useEffect(() => {
    if (currentMenuItem) {
      setMetaType(currentMenuItem.label);
      setActiveSection(currentMenuItem.id);
    }
  }, [currentMenuItem]);
  const PresetSection = useCallback(
    ({
      title,
      description,
      presetList,
      onAddNew,
      constUserList,
    }: PresetSectionProps) => (
      <>
        <div className="row gy-3">
          {!isLoading && presetList?.length > 0 ? (
            presetList?.map((item: PresetListModel) => (
              <PresetCard
                key={item.id}
                name={item?.name}
                createdBy={item?.mtbydata?.name || item?.cybydata?.name}
                createdAt={item?.mt || item?.ct}
                meta={item}
                team={item?.team}
              />
            ))
          ) : isLoading ? (
            <Skeleton type="table" count={8} />
          ) : (
            <NoContentFound message="No Preset Created. Create One" />
          )}
        </div>
      </>
    ),
    [PresetCard, isLoading, bunchProductList]
  );

  const ModalButton = useCallback(
    ({
      onClick,
      disabled,
      children,
    }: {
      onClick: () => void;
      disabled?: boolean;
      children: React.ReactNode;
    }) => (
      <Button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onClick();
        }}
        isDisabled={disabled}
      >
        {children}
      </Button>
    ),
    []
  );

  // Reusable delete button component
  const DeleteButton = useCallback(
    ({ onClick }: { onClick: () => void }) => (
      <span
        className="btn-danger bg-light shadow-lg p-2 rounded-3 border pointer"
        style={{ color: "red", border: "none" }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onClick();
        }}
      >
        Delete
      </span>
    ),
    []
  );

  // Options dropdown component
  const OptionsDropdown = useCallback(
    ({
      isVisible,
      onToggle,
      onDelete,
    }: {
      isVisible: boolean;
      onToggle: () => void;
      onDelete: () => void;
    }) => (
      <Dropdown
        align="end"
        show={isVisible}
        onToggle={() => onToggle()}
        className="ms-2 px-0"
      >
        <Dropdown.Toggle
          id="preset-options"
          variant="light"
          className="border-0 no-caret"
        >
          <EllipsisVertical size={20} />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item
            onClick={(e: any) => {
              e.preventDefault();
              e.stopPropagation();
              onDelete();
            }}
          >
            Delete
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    ),
    [DeleteButton]
  );

  // Transcoding dropdown component
  const TranscodingDropdown = useCallback(
    () => (
      <div className="position-relative" ref={transcodingDropdownRef}>
        <Button
          onClick={() =>
            setIsTranscodingDropdownOpen(!isTranscodingDropdownOpen)
          }
          type="outline-primary"
          className="d-flex align-items-center gap-2 hover-icon-white"
        >
          Add{" "}
          <i
            className={`bi bi-chevron-${
              isTranscodingDropdownOpen ? "down" : "right"
            } transition-transform`}
          ></i>
        </Button>
        <style>
          {`
          .hover-icon-white:hover i {
            color: white !important;
          }
        `}
        </style>
        {isTranscodingDropdownOpen && (
          <div
            className="position-absolute top-60 end-0 mt-2 bg-white border rounded shadow-sm"
            style={{ width: "100px" }}
          >
            <div className="d-flex flex-column gap-2">
              <div
                className="dropdown-item"
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  setTranscodingModalType("audio");
                  updateModalState("isTranscodingPreset", true);
                  setIsTranscodingDropdownOpen(false);
                }}
              >
                Audio
              </div>
              <div
                className="dropdown-item"
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  setTranscodingModalType("video");
                  updateModalState("isTranscodingPreset", true);
                  setIsTranscodingDropdownOpen(false);
                }}
              >
                Video
              </div>
            </div>
          </div>
        )}
      </div>
    ),
    [isTranscodingDropdownOpen, updateModalState]
  );

  // Render preset sections

  // Render current preset section
  const renderCurrentPresetSection = useMemo(() => {
    const currentPresetList =
      presetLists[activeTab as keyof typeof presetLists] || [];

    return (
      <PresetSection
        title={currentPresetConfig.title}
        description={currentPresetConfig.description}
        presetList={currentPresetList}
        onAddNew={createAddNewHandler(activeTab)}
        constUserList={constUserList}
      />
    );
  }, [
    activeTab,
    currentPresetConfig,
    presetLists,
    createAddNewHandler,
    constUserList,
    PresetSection,
  ]);

  return (
    <div className="container position-relative">
      <PageHeader
        title={
          <>
            Presets -{" "}
            <span className="text-secondary">
              {(getCurrentMenuItem()?.label || metaType).toUpperCase()}
            </span>
          </>
        }
        buttonText={activeTab === "transcoding" ? undefined : "ADD NEW"}
        onButtonClick={
          activeTab === "transcoding"
            ? undefined
            : createAddNewHandler(activeTab)
        }
        backPath="/setting"
      >
        {activeTab === "transcoding" ? <TranscodingDropdown /> : undefined}
      </PageHeader>
      <div className="row m-0 p-4 z-1 position-relative">
        <SidebarNavigation
          menuItems={sidebarMenuItems}
          activeItem={activeSection}
          onItemClick={setActiveSection}
          className="col-sm-5 col-md-4 col-lg-3 sidebar-top"
        />
        <div className="col-sm-7 col-md-8 col-lg-9 gap-3">
          {renderCurrentPresetSection}
        </div>
      </div>

      {/* Modals */}
      {/* {modalStates.isShowAddNew && (
        <Modal
          isOpen={modalStates.isShowAddNew}
          onClose={closeModal}
          title={isEdit ? "Edit Meta Preset" : "Create Meta Preset"}
          width="990px"
          height="100%"
          footer={
            <div className="d-flex align-items-center w-100 justify-content-between">
              {!isEdit && <Button onClick={handleBack}>Back</Button>}
              <div className="d-flex justify-content-end w-100 align-items-center position-relative">
                <ModalButton onClick={handleCreate} disabled={!hasChanges}>
                  {isEdit ? "Update" : "Create"}
                </ModalButton>
                {isEdit && (
                  <OptionsDropdown
                    isVisible={showOptions}
                    onToggle={() => setShowOptions(!showOptions)}
                    onDelete={() => {
                      for (const product of productList) {
                        if (product?.presets?.[meta?.type || ""] === meta?.id) {
                          // window.alert('This meta preset is used in a product');
                          toast.fail("This meta preset is used in a product");
                          return;
                        }
                      }

                      setConfirmModalOpen(true);
                    }}
                  />
                )}
              </div>
            </div>
          }
          closeOnOutsideClick={false}
        >
          <CreateMetaPreset
            selectedMedia={prevMediaMeta}
            item={isEdit ? currentPresetDetails || meta : meta}
            onSubmit={handleSubmit}
            onHasChanges={handleHasChanges}
            isEdit={isEdit}
          />
        </Modal>
      )} */}

      {modalStates.isShowProcessing && (
        <Modal
          isOpen={modalStates.isShowProcessing}
          onClose={closeModal}
          title={isEdit ? "Edit Processing Preset" : "Create Processing Preset"}
          width="990px"
          height="auto"
          footer={
            <div className="d-flex justify-content-end w-100 align-items-center position-relative">
              <ModalButton
                onClick={handleCreate}
                disabled={isSocialBtnDisabled}
              >
                {isEdit ? "Update" : "Create"}
              </ModalButton>
              {isEdit && (
                <OptionsDropdown
                  isVisible={showOptions}
                  onToggle={() => setShowOptions(!showOptions)}
                  onDelete={() => {
                    for (const product of productList) {
                      if (product?.presets?.[meta?.type || ""] === meta?.id) {
                        // window.alert('This meta preset is used in a product');
                        toast.fail("This meta preset is used in a product");

                        return;
                      }
                    }

                    setConfirmModalOpen(true);
                  }}
                />
              )}
            </div>
          }
          closeOnOutsideClick={false}
        >
          <ProcessingPreset
            presetList={presetList}
            genre={genre}
            Language_Options={bunchLanguage?.list?.map((item: any) => ({
              label: item?.name,
              value: item?.name,
            }))}
            onSubmit={handleProcessingSubmit}
            item={meta}
            bunchProductList={bunchProductList}
            setIsSocialBtnDisabled={setIsSocialBtnDisabled}
          />
        </Modal>
      )}

      {modalStates.isShowSocial && (
        <Modal
          isOpen={modalStates.isShowSocial}
          onClose={closeModal}
          title={isEdit ? "Edit Social Preset" : "Create Social Preset"}
          width="990px"
          height="100%"
          // footer={<ModalButton onClick={handleCreate}>{isEdit ? 'Update' : 'Create'}</ModalButton>}
          footer={
            <div className="d-flex align-items-center w-100">
              {!isEdit && <Button onClick={handleBack}>Back</Button>}

              <div className="d-flex justify-content-end w-100 align-items-center position-relative">
                <ModalButton
                  disabled={isSocialBtnDisabled}
                  onClick={handleCreate}
                >
                  {isEdit ? "Update" : "Create"}
                </ModalButton>
                {isEdit && (
                  <OptionsDropdown
                    isVisible={showOptions}
                    onToggle={() => setShowOptions(!showOptions)}
                    onDelete={() => {
                      for (const product of productList) {
                        if (product?.presets?.[meta?.type || ""] === meta?.id) {
                          // window.alert('This meta preset is used in a product');
                          toast.fail("This meta preset is used in a product");

                          return;
                        }
                      }

                      setConfirmModalOpen(true);
                    }}
                  />
                )}
              </div>
            </div>
          }
          closeOnOutsideClick={false}
        >
          <SocialPresets
            liveList={liveList?.map((item: any) => ({
              label: item?.title,
              value: item?.id,
            }))}
            onSubmit={handleSocialSubmit}
            business={business}
            item={meta}
            selectedMedia={isEdit ? meta : prevMediaMeta}
            isEdit={isEdit}
            setIsSocialBtnDisabled={setIsSocialBtnDisabled}
            productList={bunchProductList}
            presetList={presetList}
            singleCurrentUser={singleCurrentUser}
          />
        </Modal>
      )}

      {modalStates.isPrevMediaList && (
        <Modal
          isOpen={modalStates.isPrevMediaList}
          onClose={closeModal}
          title="Select Media for Meta Preset"
          width="990px"
          height="100vh"
          // footer={<ModalButton onClick={handleSelectMedia}>Next</ModalButton>}
          closeOnOutsideClick={false}
        >
          <PreviousMediaMeta
            type={activeTab}
            onSubmit={handlePrevMediaMeta}
            selectedMediaDetails={prevMediaMeta}
            openModal={openModal}
          />
        </Modal>
      )}

      {isConfirmModalOpen && (
        <Modal
          isOpen={isConfirmModalOpen}
          onClose={() => {
            setConfirmModalOpen(false);
          }}
          title=""
          width="500px"
          footer={
            <div className="d-flex justify-content-center gap-2 w-100 align-items-center">
              <Button
                type="outline-primary"
                onClick={() => {
                  setConfirmModalOpen(false);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                style={{ border: "none" }}
                onClick={() => {
                  handleDelete(meta || null);
                  setConfirmModalOpen(false);
                }}
              >
                Confirm
              </Button>
            </div>
          }
        >
          <div className="d-flex flex-column justify-content-center align-items-center">
            <div className="my-3">
              <i className="bi bi-exclamation-triangle-fill fs-5 me-2 text-danger"></i>
              <span className="fs-5 text-danger">ALERT!</span>
            </div>
            <p>Are you sure you want to delete this content?</p>
          </div>
        </Modal>
      )}

      {modalStates.isBrandingPreset && (
        <Modal
          isOpen={modalStates.isBrandingPreset}
          onClose={closeModal}
          title={isEdit ? "Edit Branding Preset" : "Create Branding Preset"}
          width="1000px"
          height="100%"
          footer={
            <div className="d-flex justify-content-between w-100 align-items-center position-relative">
              <span className="d-flex align-items-center text-muted">
                Duration: {secondsToHms(duration)}
              </span>
              <div className="d-flex ">
                <ModalButton
                  onClick={handleCreate}
                  disabled={isSocialBtnDisabled}
                >
                  {isEdit ? "Update" : "Create"}
                </ModalButton>
                {isEdit && (
                  <OptionsDropdown
                    isVisible={showOptions}
                    onToggle={() => setShowOptions(!showOptions)}
                    onDelete={() => {
                      for (const product of productList) {
                        if (product?.presets?.[meta?.type || ""] === meta?.id) {
                          window.alert("This meta preset is used in a product");

                          return;
                        }
                      }

                      setConfirmModalOpen(true);
                    }}
                  />
                )}
              </div>
            </div>
          }
          // footer={<ModalButton onClick={handleCreate}>{isEdit ? 'Update' : 'Create'}</ModalButton>}
        >
          <BrandingPreset
            item={mediaList[20]}
            onSubmit={handleBrandingSubmit}
            presetData={meta}
            isEdit={isEdit}
            OnCloseModal={closeModal}
            isPreset={true}
            setIsBrandingBtnDisabled={setIsSocialBtnDisabled}
            setDuration={setDuration}
          />
        </Modal>
      )}

      {modalStates.isTranscodingPreset && (
        <Modal
          isOpen={modalStates.isTranscodingPreset}
          onClose={closeModal}
          title={
            isEdit ? "Edit Transcoding Preset" : "Create Transcoding Preset"
          }
          width="896px"
          height="auto"
          closeOnOutsideClick={false}
          footer={
            <div className="d-flex justify-content-end w-100 align-items-center position-relative">
              <ModalButton
                onClick={handleCreate}
                disabled={!hasTranscodingChanges}
              >
                {isEdit ? "Update" : "Create"}
              </ModalButton>
              {isEdit && (
                <OptionsDropdown
                  isVisible={showOptions}
                  onToggle={() => setShowOptions(!showOptions)}
                  onDelete={() => setConfirmModalOpen(true)}
                />
              )}
            </div>
          }
        >
          <AddPreset
            handleSave={handleSave}
            preset_type={transcodingModalType || "video"}
            isEdit={isEdit}
            bunchProductList={bunchProductList}
            presetData={meta}
            onHasChanges={handleTranscodingHasChanges}
          />
        </Modal>
      )}
    </div>
  );
};

const mapState = (state: RootState) => ({
  categories: state.app.categories,
  // language: state.app.metaLanguage,
  mediaList: state.media.mediaList.list,
  agencies: state.app.agencies,
  categoryList: state.media.categoryList,
  category: state.app.category,
  bunchLanguage: state.constants.bunchLanguageList,
  tag: state.app.tag,
  cast: state.app.cast,
  genre: state.app.genre,
  isLoading: state.media.presetList.isLoading,
  mostFrequentUsers: state.users.mostFrequentUsers,
  mostFrequentEditor: state.users.mostFrequentEditor,
  mostFrequentScriptWriter: state.users.mostFrequentScriptWriter,
  mostFrequentAnchor: state.users.mostFrequentAnchor,
  mostFrequentCameraman: state.users.mostFrequentCameraman,
  mostFrequentContentType: state.users.mostFrequentContentType,
  mostFrequentCategory: state.users.mostFrequentCategory,
  constUserList: state.app.constUserList,
  creditList: state.media.creditList,
  audioCreditList: state.media.audioCreditList,
  videoCreditList: state.media.videoCreditList,
  imageCreditList: state.media.imageCreditList,
  presetList: state.media.presetList.list,
  liveList: state.media.liveList.list,
  business: state.users.singleCurrentUser?.business,
  singleCurrentUser: state.users.singleCurrentUser,
  bunchProductList: state.constants.bunchProductList.list,
  currentPresetDetails: state.media.currentPresetDetails.data,
  productList: state.constants.productList.list,
  bunchLanguageList: state.constants.bunchLanguageList.list,
  bunchCategoryList: state.constants.bunchCategoryList.list,
  bunchBusinessList: state.constants.bunchBusinessList.list,
});

const mapDispatch = {
  getMostFrequentAll,
  getLiveList,
  getPresetList,
  getAddPreset,
  updatePreset,
  deletePreset,
  getListMedia,
  setPresetList,

  getCurrentPresetDetails,
  getListProduct,
};

const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector> & RenderCreateMetaPresetProps;
export default connector(MetaPresets);
